import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";
import CmsComponentLink from "@/helpers/editor/components/CmsComponentLink.js";

/**
 * Specialized class to customize the map
 */
export default class CmsBlockMapRatingPopup extends CmsBlock {
    static typeDef = {
        name: `Rating Popup|Fenêtre d'évaluation`,
        glyph: `fas fa-star`,
        type: `map-rating-popup`,
        category: `widget`,
        isParent: true
    }

    constructor(data, page) {
        super(data, page);
    }
}
